import { Injectable, Injector } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpHeaders
} from "@angular/common/http";
import { EMPTY, Observable, of, throwError } from "rxjs";
import { JwtAuthService } from "../services/auth/jwt-auth.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { catchError, takeUntil } from "rxjs/operators";
import { AppConfirmService } from './../services/app-confirm/app-confirm.service';
import { EmpresaContextService } from '../services/empresa-context.service';
import { Router } from "@angular/router";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  private contextResetPromptOpen = false;
  private semAutorizacaoPromptOpen = false;

  constructor(private jwtAuth: JwtAuthService, private appConfirmService: AppConfirmService,
    private empresaContext: EmpresaContextService, private router: Router) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    // req.url.
    const re = 'viacep.com.br/ws';
    const r2 = '/receitaws/';

    // Exclude interceptor for login request:
    const publicAuthEndpoints = [
      '/auth/signin',
      '/auth/signup',
      '/auth/recovery/pass',
      '/auth/email/confirma',
      '/email/change/pass',
      '/auth/user/confirm'
    ];

    const isPublicAuthRequest = publicAuthEndpoints.some(path => req.url.includes(path));

    if (req.url.search(re) > -1 || req.url.search(r2) > -1 || isPublicAuthRequest) {
      return next.handle(req);
    }

    // Notificações CENTRAIS da Infokaw (getNotificacoesValidasInfokaw) usam URL absoluta
    // para https://infokaw.com.br/api/notificacao. Na INTRANET a página é servida por outro
    // host (ex.: http://SERVIDOR), então essa chamada é cross-origin e o token JWT LOCAL não
    // vale no servidor central — enviá-lo pode causar 401 no filtro de auth. Tratamos como
    // pública (sem token). Na NUVEM a página está em infokaw.com.br (mesma origem), a condição
    // é falsa e o token continua sendo enviado normalmente — comportamento inalterado.
    const isExternalInfokawNotif = req.url.includes('infokaw.com.br/api/notificacao')
      && typeof window !== 'undefined'
      && !window.location.origin.includes('infokaw.com.br');
    if (isExternalInfokawNotif) {
      return next.handle(req);
    }

    const correiosSoap = '/calculador/';
    if (req.url.search(correiosSoap) > -1) {
      let headers = new HttpHeaders();
      headers = headers.append('Content-Type', 'xml/text');
      req.clone({ headers: headers });
      return next.handle(req);
    }


    //  const loja$ = this.jwtAuth.getLojaSeleted$();
    //  const authReq = req.clone({headers:
    //      (loja$ != null &&  loja$.getValue() != null &&
    //      req.url.search(loja$.getValue().url_api) > -1 ) ? this.getHeadersLoja() :  this.getHeaders()});
    //   console.log('COLOCANDO TOKEN:' + localStorage.getItem('token') + '\n na CHAMADA' + req.url );



    var token = this.jwtAuth.token || this.jwtAuth.getJwtToken();
    // console.log('ITEM EM REQ:' + JSON.stringify(this.jwtAuth.item$?.value) + '\n na CHAMADA' + req.url );

    if (this.jwtAuth.item$?.value?.remoto && this.jwtAuth.item$?.value?.empresaRemota !== null
      && this.jwtAuth.item$?.value?.empresaRemota !== undefined && req.url.search(this.jwtAuth.item$?.value?.empresaRemota.urlApi) > -1) {
      // Sem token remoto (ex.: login só-central) mantém o token local: trocar por nulo mandava a
      // requisição sem Authorization.
      token = this.jwtAuth.tokenRemoto || this.jwtAuth.getJwtTokenRemoto() || token;
      // console.log('COLOCANDO TOKEN:' + token + '\n na CHAMADA' + req.url );
    }
    var changedReq;

    if (token) {

      changedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        },
      });

    } else {

      changedReq = req;
    }



    // takeUntil(signout$): ao sair/trocar de empresa o token é apagado, mas as requisições já
    // disparadas continuam vivas e voltam 401/403 — o que abria o aviso "Não Autorizado"
    // repetidamente, inclusive já na tela de login. Cancelamos essas pendências no signout.
    return next.handle(changedReq).pipe(
      catchError(x => this.handleAuthError(x)),
      takeUntil(this.jwtAuth.signout$)
    );
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    // Sem sessão (logout, troca de empresa, sessão expirada) o 401/403 não é falta de permissão
    // do usuário: é resposta de requisição órfã. Avisar aqui só polui a tela de login.
    if (!this.temSessaoAtiva()) {
      // Token apagado com a tela ainda aberta (signout em outra aba limpa o localStorage da
      // origem toda; o AuthGuard só confere na entrada da rota): sem isto a tela ficava viva e
      // cada clique morria calado. Leva ao login uma vez; fora da área logada não faz nada.
      if (err.status === 401 && !this.router.url.startsWith('/sessions')) {
        this.jwtAuth.signout();
      }
      // EMPTY: a requisição simplesmente não entrega nada. Propagar o erro faria cada tela ainda
      // viva abrir o SEU próprio aviso de falha — a mesma poluição com outro texto.
      return EMPTY;
    }

    if (this.isEmpresaContextError(err)) {
      this.promptSelecionarEmpresaNovamente();
      return throwError(err);
    }

    if (err.status === 403) {
      // Antes de culpar a permissão do usuário: se ele está na empresa central (Infokaw) SEM acesso
      // efetivo lá e tem empresa própria, o problema é o contexto de empresa, não a role.
      // A própria consulta de empresas não pode reentrar aqui (evita recursão).
      if (!(err.url ?? '').includes('/me/empresa') && this.empresaContext.deveAvisarEmpresaIncorreta()) {
        this.empresaContext.temOutraEmpresa$().subscribe((temOutra) => {
          if (temOutra) {
            this.empresaContext.promptEmpresaIncorreta('403');
          } else {
            this.confirmSemAutorizacao();
          }
        });
        return of(err.message);
      }

      this.confirmSemAutorizacao();

      return of(err.message);

    } else if (err.status === 401) {

    }
    return throwError(err);
  }

  private confirmSemAutorizacao(): void {
    // Uma tela costuma disparar várias chamadas ao mesmo tempo; sem essa trava o usuário
    // fecha um aviso e cai no próximo, um por requisição negada.
    if (this.semAutorizacaoPromptOpen) {
      return;
    }

    this.semAutorizacaoPromptOpen = true;
    this.appConfirmService.confirm({
      title: 'A T E N Ç Ã O !', message:
        'Não Autorizado!Você não tem autorização p/ fazer esta operação, contate o Administrador!', error: true
    }).subscribe(() => this.semAutorizacaoPromptOpen = false);
    console.log('Não Autorizado!Você não tem autorização p/ fazer esta operação, contate o Administrador!');
  }

  /**
   * Sessão ativa = ainda existe token. Sem token não há o que autorizar: o 401/403 é de requisição
   * órfã (logout, troca de empresa, sessão expirada), não de permissão do usuário.
   */
  private temSessaoAtiva(): boolean {
    return !!(this.jwtAuth.token || this.jwtAuth.getJwtToken());
  }

  private promptSelecionarEmpresaNovamente(): void {
    if (this.contextResetPromptOpen) {
      return;
    }

    this.contextResetPromptOpen = true;
    this.jwtAuth.clear();

    this.appConfirmService.confirm({
      title: 'Sessão sem empresa ativa',
      message: 'Sua sessão perdeu o contexto da empresa/filial. Selecione a empresa novamente para continuar.',
      error: true,
      okText: 'Selecionar empresa',
      cancelText: 'Sair'
    }).subscribe((confirmado) => {
      this.contextResetPromptOpen = false;
      if (confirmado) {
        this.router.navigateByUrl('/profile/filial');
        return;
      }

      this.jwtAuth.signout();
    });
  }

  private isEmpresaContextError(err: HttpErrorResponse): boolean {
    // Não interromper o fluxo intencional de troca de empresa ou autenticação
    const url = err.url ?? '';
    if (url.includes('/me/empresa/select/')
      || url.includes('/auth/signin')
      || url.includes('/auth/signup')
      || url.includes('/auth/recovery')) {
      return false;
    }

    const msg = this.extractErrorMessage(err).toLowerCase();
    if (!msg) {
      return false;
    }

    return msg.includes('filial não encontrado')
      || msg.includes('filial nao encontrado')
      || msg.includes('filial não encontrada')
      || msg.includes('filial nao encontrada')
      || msg.includes('empresa não encontrada')
      || msg.includes('empresa nao encontrada')
      || msg.includes('não foi possível determinar a filial')
      || msg.includes('nao foi possivel determinar a filial')
      || msg.includes('user not found with id');
  }

  private extractErrorMessage(err: HttpErrorResponse): string {
    if (!err) {
      return '';
    }

    const e = err.error;
    if (typeof e === 'string') {
      return e;
    }

    if (e && typeof e === 'object') {
      const status = (e.status ?? '').toString();
      const message = (e.message ?? '').toString();
      const error = (e.error ?? '').toString();
      return [status, message, error].filter(Boolean).join(' | ');
    }

    return (err.message ?? '').toString();
  }

 

 


}
